/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbTeamSummary
 */
export interface HchbTeamSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbTeamSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbTeamSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbTeamSummary
     */
    external_id?: string;
}

/**
 * Check if a given object implements the HchbTeamSummary interface.
 */
export function instanceOfHchbTeamSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function HchbTeamSummaryFromJSON(json: any): HchbTeamSummary {
    return HchbTeamSummaryFromJSONTyped(json, false);
}

export function HchbTeamSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbTeamSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
    };
}

export function HchbTeamSummaryToJSON(value?: HchbTeamSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'external_id': value.external_id,
    };
}

